<div [class]="specialBlock.uId">
  <app-lightbox-basic-view
    [block]="basicView"
    [class]="basicView.uId"
    [settings]="settings">
  </app-lightbox-basic-view>
  <div >
    <app-lightbox-preview-view [@openClose]="isPreviewOpened ? 'open' : 'closed'" [block]="photoPreviewView"
      [class]="photoPreviewView.uId"
      [isPreviewOpened]="isPreviewOpened"
      >
    </app-lightbox-preview-view>
  </div>

</div>
